import React, { useState } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../GenericComponent/HeaderSub/headersub";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { TableCheckThongTinKh } from "./TableCheckThongTinKh";

export const CheckThongTinKh = () => {
  const initDataSearch = {
    code: "",
  };
  const [dataSearch, setDataSearch] = useState(initDataSearch);
  const onChangeCode = (value) => {
    setDataSearch({
      ...dataSearch,
      code: value,
    });
    //alert(dataSearch.code);
  };

  const ListCheckThongTinKh = (dataSearch) => {
    //return getListNhanVay(dataSearch);
  };
  return (
    <Layout>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <Headersub
                title="Check thông tin khách hàng"
                icon1="mdi mdi-account-multiple-check"
              />
              <SearchBarDesktop data={dataSearch} onChangeCode={onChangeCode} />
              <SearchBarMobile data={dataSearch} onChangeCode={onChangeCode} />
            </div>
          </div>
        </div>
        <TableCheckThongTinKh data={dataSearch} />
      </div>
    </Layout>
  );
};
